import { CreditCardIcon, WalletIcon } from '@heroicons/react/24/outline';
import type { LogoView } from '../utils/payment-method-view';

interface PaymentMethodLogoProps {
  logo: LogoView;
  /** Classes for the <img> of an asset (and of the older backend's sourceless image). */
  imgClassName: string;
  /** Classes for the generic glyph. */
  glyphClassName: string;
}

/**
 * A payment method's logo: its asset, or a generic glyph that screen readers name like the
 * image it stands in for. heroicons hide their svg from assistive tech by default, so the
 * glyph turns that off and carries the method's name itself.
 */
export const PaymentMethodLogo = ({
  logo,
  imgClassName,
  glyphClassName
}: PaymentMethodLogoProps) => {
  switch (logo.kind) {
    case 'asset':
      return <img src={logo.src} alt={logo.alt} className={imgClassName} />;
    case 'missing':
      return <img alt={logo.alt} className={imgClassName} />;
    case 'generic': {
      const Glyph = logo.glyph === 'card' ? CreditCardIcon : WalletIcon;
      return (
        <Glyph
          role="img"
          aria-hidden={false}
          aria-label={logo.alt}
          data-glyph={logo.glyph}
          className={glyphClassName}
        />
      );
    }
  }
};
